import styled from 'styled-components';

export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Content = styled(FlexColumn)`
	margin-top: 12px;
	gap: 20px;
	padding: 16px;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 8px;
	padding-bottom: 36px;
`;

export const CheckboxContainer = styled.div`
	margin-top: -1px;
	margin-right: -1px;
	width: 20px;
	height: 20px;
`;

export const DropdownContainer = styled.div`
	width: 100px;
`;

export const Setting = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0;
	padding: 0;
	min-height: 20px;
`;

export const SettingRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
	height: 20px;
	flex-shrink: 0;
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const Label = styled.p`
	font-size: 12px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 2px;
	width: 280px;
`;

export const Choice = styled.div`
	// align contents to the right
	justify-content: flex-end;
`;

export const SectionHeader = styled.p`
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	margin-top: 24px;
	margin-bottom: -4px;
	padding-bottom: 8px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[400]};
`;

export const FirstSectionHeader = styled(SectionHeader)`
	margin-top: 0;
`;

export const DescriptionRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
	margin-top: 4px;
`;

export const Description = styled.p`
	font-size: 11px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[700]};
	margin: 0;
	padding: 0;
	width: 280px;
	line-height: 1.4;
`;
